import * as types from "../actions/types";



const initialState = {
  loading: false,
  authError: null,
};


export default function auth (state = initialState, action) {
  switch (action.type) {
    case types.SET_AUTH_DATA:
      return {
        ...state,
        ...action.payload,
        authError: null,
      };

    case types.SIGNED_OUT:
      return {
        ...initialState
      };
    
    case types.SET_AUTH_ERROR:
      return {
        ...state,
        authError: action.payload,
      };

    case types.SET_AUTH_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}